import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.features.attach-invoice-to-matched-items.presenters.AttachInvoiceToMatchedItemsPresenter`

export default defineMessages({
  successTitle: {
    id: `${scope}.successTitle`,
    defaultMessage: 'Success',
  },
  successMessage: {
    id: `${scope}.successMessage`,
    defaultMessage: 'Invoice has been attached to the selected items',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  genericErrorMessage: {
    id: `${scope}.genericErrorMessage`,
    defaultMessage: 'Unable to attach the invoice. Please try again.',
  },
})
